/*
 * Méga-menu « verre » : ouverture au survol à la souris et préchargement des images du panneau.
 *
 * S'appuie sur l'API publique du composant du thème (assets/dropdown.js : open(), close(), isOpen),
 * sans le modifier. Le clic, le clavier (Entrée, flèche bas, Échap) et le tactile restent gérés par le thème.
 * Actif uniquement sur écran large avec une vraie souris.
 */
(() => {
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 240;
  const finePointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function enhance(group) {
    const items = [...group.querySelectorAll('dropdown-component.rr-mm-glass')];

    items.forEach((item) => {
      let openTimer;
      let closeTimer;
      let openedByHover = false;

      // Les images d'un panneau masqué sont en loading="lazy" : sans cela, elles ne démarrent qu'à l'ouverture
      // et la carte reste blanche un instant. On les libère dès que la souris approche du bouton.
      const warmImages = () => {
        item.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      };

      const closeSiblings = () => {
        group.querySelectorAll('dropdown-component').forEach((other) => {
          if (other !== item && other.isOpen) other.close();
        });
      };

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !finePointer.matches) return;
        clearTimeout(closeTimer);
        warmImages();
        if (item.isOpen) return;
        openTimer = setTimeout(() => {
          closeSiblings();
          item.open();
          openedByHover = true;
        }, OPEN_DELAY);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || !finePointer.matches) return;
        clearTimeout(openTimer);
        if (!openedByHover) return;
        closeTimer = setTimeout(() => {
          if (item.isOpen) item.close();
          openedByHover = false;
        }, CLOSE_DELAY);
      });

      // Un clic sur le bouton, juste après une ouverture au survol, ne doit pas refermer le menu.
      item.addEventListener(
        'click',
        (event) => {
          const toggle = event.target.closest('[data-ref="dropdown-toggle"]');
          if (toggle && openedByHover && finePointer.matches) {
            event.stopImmediatePropagation();
            event.preventDefault();
            openedByHover = false;
          }
        },
        true
      );

      // Si le thème ferme le menu (Échap, clic ailleurs), on oublie l'état « ouvert au survol ».
      new MutationObserver(() => {
        if (item.getAttribute('data-open') !== 'true') openedByHover = false;
      }).observe(item, { attributes: true, attributeFilter: ['data-open'] });
    });
  }

  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    document.querySelectorAll('dropdown-group-component').forEach(enhance);
  };
  const boot = () => customElements.whenDefined('dropdown-component').then(start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
